export default __webpack_public_path__ + "static/media/trashIcon.9f68151e.svg";